module.exports = __webpack_public_path__ + "img/form1.38931948.png";